export enum FileUploadTargetType {
  CloudItemFile = 'cloud-item-file',
  DatabaseItemCellFile = 'database-item-cell-file',
  DatabaseItemInlineImage = 'database-item-inline-image',
  ConversationMessageFile = 'conversation-message-file',
  DocumentFile = 'document-file',
  DatabaseImportSource = 'database-import-source',
  DatabaseViewPayloadFile = 'database-view-payload-file',
  UserAvatar = 'user-avatar',
  UserCover = 'user-cover',
  WorkspaceLogo = 'workspace-logo',
  AppIcon = 'app-icon',
  CallBackground = 'call-background',
  WhiteboardImage = 'whiteboard-image',
  AgentAvatar = 'agent-avatar',
}
